<template>
  <v-card
    :color="color"
    elevation="0"
    class="a-card-pricing-strategy-strategy-rule fill-height"
  >
    <v-card-text
      class="fill-height d-flex flex-column"
      :class="mini ? 'px-1 pb-1 pt-6' : 'pa-3 pt-2 pb-2'"
      style="gap:4px"
    >
      <div
        v-if="!mini"
        class="text-caption font-weight-medium text-truncate line-height-1 text-center mx-auto"
        style="max-width: calc(100% - 90px);"
      >
        {{ rule.name }}
      </div>
      <div class="flex-grow-1 d-flex align-center justify-center">
        <a-pricing-strategy-rule-graph
          :rule="rule"
          :color="graphColor"
          :mini="mini"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Cuerpo visual de una card de regla: nombre + grafo.
 *
 * Lo comparten la card de regla de la grid y la card de guardarail, para que
 * ambas se vean iguales por construcción y no por copia.
 */
import aPricingStrategyRuleGraph from "@/components/pricing-strategy/aPricingStrategyRuleGraph.vue";
import * as Utils from "@/utils.js";

export default {
  name: "a-pricing-strategy-card-rule-body",
  components: {
    aPricingStrategyRuleGraph
  },
  props: {
    rule: {
      type: Object,
      required: true
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    color() {
      return this.rule.color;
    },
    graphColor() {
      return Utils.intensifyColor(this.color);
    }
  }
};
</script>
